export enum OrganizationSettingsEnum {
    VISIT_MIN_RADIUS_METERS = 'stork:visit_min_radius_meters',
    VISIT_MIN_PERMANENCE_MINUTES = 'stork:visit_min_permanence_minutes',
    ZONE_MIN_PERMANENCE_MINUTES = 'stork:zone_min_permanence_minutes',
    DRIVER_STOP_MAX_TIME_MINUTES = 'stork:driver_stop_max_time_minutes',
    STOP_STOPOVER_THRESHOLD_MINUTES = 'stork:stop_stopover_threshold_minutes',
    DEVICE_INSTANT_MAX_SPEED = 'stork:device_instant_max_speed', // number, expressed in km/h
    DEVICE_SUSTAINED_MAX_SPEED = 'stork:device_sustained_max_speed', // number, expressed in km/h
    DEVICE_SUSTAINED_MAX_SPEED_THRESHOLD_MINUTES = 'stork:device_sustained_max_speed_threshold_minutes',
    DEVICE_SAFE_ROUTE_DEVIATION_MAX_DISTANCE_METERS = 'stork:device_safe_route_deviation_max_distance_meters', // number, expressed in meters
    SPEED_EVENT_MIN_SATELLITES = 'stork:speed_event_min_satellites', // number, tracker positions with fewer satellites are ignored for speed events

    // ENABLED
    VISITS_EVENTS_ENABLED = 'stork:visits_events_enabled',
    STOP_EVENTS_ENABLED = 'stork:stop_events_enabled',
    DEVICE_INSTANT_MAX_SPEED_ENABLED = 'stork:device_instant_max_speed_enabled',
    DEVICE_SUSTAINED_MAX_SPEED_ENABLED = 'stork:device_sustained_max_speed_enabled',
    DEVICE_SAFE_ROUTE_DEVIATION_ENABLED = 'stork:device_safe_route_deviation_enabled',
    TACHOGRAPH_DATA_ENABLED = 'stork:tachograph_data_enabled',
    REORDER_CHECKPOINTS_ENABLED = 'stork:reorder_checkpoints_enabled',
    CARRIER_USER_CAN_ASSIGN_VEHICLES_AND_DRIVERS_ENABLED = 'stork:carrier_user_can_assign_vehicles_and_drivers_enabled',
    CARRIER_USER_CAN_CREATE_TRIPS_ENABLED = 'stork:carrier_user_can_create_trips_enabled',
    MULTI_TRIP_ORDERS_ENABLED = 'stork:multi_trip_orders_enabled',
    UPDATE_ORDERS_FROM_TRIP_ENABLED = 'stork:update_orders_from_trip_enabled',
    COMPLETE_CHECKPOINT_ON_APP_STEP_TRIGGER_ENABLED = 'stork:complete_checkpoint_on_app_step_trigger_enabled',
    MANUAL_TRIGGERS_ENABLED = 'stork:manual_triggers_enabled',
    MAP_MONITORING_FULL_POSITIONS_ENABLED = 'stork:map_monitoring_full_positions_enabled',
    TRIPS_TEMPLATE_ENABLED = 'stork:trips_template_enabled',

    CERTIFIED_ORDER_EDITION_DISABLED = 'stork:certified_order_edition_disabled',
    TRIP_COMMENTS_INTERNAL_ONLY = 'stork:trip_comments_internal_only',

    SUCCESS_ORDER_REASONS = 'stork:success_order_reasons', // string[]
    FAIL_ORDER_REASONS = 'stork:fail_order_reasons', // string[]
    CERTIFICATION_REQUIREMENTS_APP = 'stork:certification_requeriments_app',
    ORDER_ITEM_REASONS = 'stork:order_item_reasons',

    WEBHOOK_EVENTS = 'stork:webhook_events',

    // TNT Notifications settings
    TNT_EMAIL_ORDER_SCHEDULED_ENABLED = 'stork:tnt_email_order_scheduled_enabled',
    TNT_EMAIL_ORDER_IN_ROUTE_ENABLED = 'stork:tnt_email_order_in_route_enabled',
    TNT_EMAIL_ORDER_SUCCEEDED_ENABLED = 'stork:tnt_email_order_succeeded_enabled',
    TNT_EMAIL_ORDER_FAILED_ENABLED = 'stork:tnt_email_order_failed_enabled',
    TNT_INCLUDE_STA = 'stork:tnt_include_sta',
    TNT_INCLUDE_ETA = 'stork:tnt_include_eta',
    TNT_INCLUDE_ORDER_ITEMS = 'stork:tnt_include_order_items',
    TNT_NOTIFICATION_MARGIN_MINUTES = 'stork:tnt_notification_margin_minutes', // number

    TNT_CONTACT_INFO_NAME = 'stork:tnt_contact_info_name',
    TNT_CONTACT_INFO_EMAIL = 'stork:tnt_contact_info_email',
    TNT_CONTACT_INFO_PHONE = 'stork:tnt_contact_info_phone',
    TNT_SHOW_CONTACT_INFO = 'stork:tnt_show_contact_info',

    // SAVED PERMISSIONS/MODULES PRESETS
    USER_PERMISSIONS_PRESETS = 'stork:user_permissions_presets',

    // SAVED VEHICLES ABM'S INPUTS
    VEHICLES_VEHICLE_TYPE = 'stork:vehicles_vehicle_types',

    // SAVED SEMITRAILERS ABM'S INPUTS
    SEMITRALERS_SEMITRAILER_TYPES = 'stork:semitrailers_semitrailer_types',
    SEMITRALERS_BRAKE_TYPES = 'stork:semitrailers_brake_types',
    SEMITRALERS_BODY_TYPES = 'stork:semitrailers_body_types',
    SEMITRALERS_LOAD_TYPES = 'stork:semitrailers_load_types',
    SEMITRAILER_SUSPENSION_TYPES = 'stork:semitrailer_suspension_types',
    SEMITRAILER_RIMS_TYPES = 'stork:semitrailer_rims_types',
    SEMITRAILERS_KING_PIN_TYPES = 'stork:semitrailers_king_pin_types',

    // ENTITY SCORE CONFIG
    SCORE_CONFIG = 'stork:score_config', // PerTripDefinitionScoreConfig

    // OPERATIONAL STANDARDS
    // GENERAL
    OPERATIVE_STANDARDS_PUNCTUALITY_TARGET = 'stork:operative_standards_punctuality_target', // number, expressed in percentage
    OPERATIVE_STANDARDS_REST_TIME = 'stork:operative_standards_rest_time', // number, expressed in minutes
    OPERATIVE_STANDARDS_MAX_DRIVING_TIME = 'stork:operative_standards_max_driving_time', // number, expressed in minutes
    // BY TRIP DEFINITION
    OPERATIVE_STANDARDS_NORMAL_LOAD_TIME = 'stork:operative_standards_normal_load_time', // number, expressed in minutes
    OPERATIVE_STANDARDS_NORMAL_UNLOAD_TIME = 'stork:operative_standards_normal_unload_time', // number, expressed in minutes
    OPERATIVE_STANDARDS_ARRIVAL_DELAY_TOLERANCE = 'stork:operative_standards_arrival_delay_tolerance', // number, expressed in minutes
    OPERATIVE_STANDARDS_EMPTY_TRIP_GOAL = 'stork:operative_standards_empty_trip_goal', // number, percentage

    // TACHOSYNC API
    TACHOSYNC_API_KEY = 'stork:tachosync_api_key',
    TACHOSYNC_DOWNLOAD_HISTORY = 'stork:tachosync_download_history',

    // SEMITRAILER CARRIER MISMATCH
    SEMITRAILER_CARRIER_MISMATCH_WARNING_ENABLED = 'stork:semitrailer_carrier_mismatch_warning_enabled', // boolean

    // TOASTER NOTIFICATIONS
    TOASTER_ALERT_TYPES = 'stork:toaster_alert_types', // AlertTypesEnum[]
    TOASTER_EVENT_TYPES = 'stork:toaster_event_types', // EventTypeEnum[]

    // SUBSCRIPTIONS
    SUBSCRIPTIONS = 'stork:subscriptions', // IOrganizationSubscription[]

    // USERS
    MAX_ALLOWED_USERS = 'stork:max_allowed_users', // number
}
